package com.cs.ejobin.ui.screens.checkout

import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.cs.ejobin.i18n.Keys
import com.cs.ejobin.i18n.t
import com.cs.ejobin.ui.components.ScreenScaffold
import com.cs.ejobin.ui.theme.AppColors
import com.cs.ejobin.ui.theme.AppSurfaces

@Composable
fun CheckoutSuccessScreen(
    onContinue: () -> Unit,
    onGoProfile: () -> Unit
) {
    val primaryTextButtonColors = ButtonDefaults.textButtonColors(contentColor = AppColors.Primary)

    ScreenScaffold(
        title = t(Keys.checkout_success_title),
        scrollable = true,
        topActions = {}
    ) {
        Card(
            modifier = Modifier
                .fillMaxWidth()
                .widthIn(max = 520.dp),
            colors = AppSurfaces.glassCard(),
            border = CardDefaults.outlinedCardBorder()
        ) {
            Column(
                modifier = Modifier.padding(16.dp),
                verticalArrangement = Arrangement.spacedBy(12.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    text = t(Keys.checkout_success_headline),
                    style = MaterialTheme.typography.titleLarge,
                    color = AppColors.TextPrimary
                )
                Text(
                    text = t(Keys.checkout_success_body),
                    style = MaterialTheme.typography.bodyMedium,
                    color = AppColors.TextPrimary
                )

                Button(
                    onClick = onContinue,
                    colors = ButtonDefaults.buttonColors(containerColor = AppColors.Primary),
                    modifier = Modifier.fillMaxWidth()
                ) {
                    Text(t(Keys.checkout_success_continue))
                }

                TextButton(
                    onClick = onGoProfile,
                    colors = primaryTextButtonColors
                ) {
                    Text(t(Keys.checkout_success_profile))
                }
            }
        }
    }
}